import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { trackShowFilters, trackApplyFilters, trackSortOrder } from './tracking';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { setOrderField, setDealType, setFavoriteEntityType } from '../../actions/filters';
import { DealTypeFilterIcons } from '../../components/DealTypeFilterIcons';
import { DealTypeFiltersModal } from '../../components/DealTypeFiltersModal';
import { DealTypeSortModal } from '../../components/DealTypeSortModal';
import { EEntityType, EDealType, EOrderField } from '../../types/filters';
import { IApplicationState } from '../../types/redux';

export const DealTypeFilterContainer = () => {
  const orderField = useSelector((state: IApplicationState) => state.filters.orderField);
  const dealType = useSelector((state: IApplicationState) => state.filters.dealType);
  const favoriteEntityType = useSelector((state: IApplicationState) => state.filters.favoriteEntityType);
  const [openSortModal, setOpenSortModal] = React.useState<boolean>(false);
  const [openFiltersModal, setOpenFiltersModal] = React.useState<boolean>(false);

  const dispatch = useDispatch();

  const setFilterOrder = React.useCallback((order: EOrderField) => {
    trackSortOrder(order);
    dispatch(setOrderField(order));
    dispatch(fetchFavoriteEntities());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setFavoriteDealType = React.useCallback((dealType: EDealType | null) => {
    dispatch(setDealType(dealType));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setEntityType = React.useCallback((entityType: EEntityType | null) => {
    dispatch(setFavoriteEntityType(entityType));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const acceptFilter = React.useCallback(() => {
    trackApplyFilters(dealType, favoriteEntityType);
    setOpenFiltersModal(false);
    dispatch(setDealType(dealType));
    dispatch(setFavoriteEntityType(favoriteEntityType));
    dispatch(fetchFavoriteEntities());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealType, favoriteEntityType]);

  const resetFilter = React.useCallback(() => {
    setOpenFiltersModal(false);
    dispatch(fetchFavoriteEntities());
    dispatch(setDealType(null));
    dispatch(setFavoriteEntityType(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openFilters = React.useCallback(() => {
    trackShowFilters();
    setOpenFiltersModal(true);
  }, []);

  const openSort = React.useCallback(() => {
    setOpenSortModal(true);
  }, []);

  const closeFilter = React.useCallback(() => {
    setOpenFiltersModal(false);
  }, []);

  const closeSort = React.useCallback(() => {
    setOpenSortModal(false);
  }, []);

  return (
    <>
      <DealTypeFilterIcons openFilters={openFilters} openSort={openSort} entityType={favoriteEntityType} />
      <DealTypeSortModal
        orderField={orderField}
        open={openSortModal}
        setFilterOrder={setFilterOrder}
        closeSort={closeSort}
      />
      <DealTypeFiltersModal
        open={openFiltersModal}
        favoriteEntityType={favoriteEntityType}
        dealType={dealType}
        setDealType={setFavoriteDealType}
        setEntityType={setEntityType}
        closeFilter={closeFilter}
        accept={acceptFilter}
        reset={resetFilter}
      />
    </>
  );
};
